import React, { Fragment } from 'react';
import { ContentContainer, ScrollContainer } from './Swipeable.elements';
import { times } from '../../../../play-core/utils/times';
import { useVideoConfig } from '../../config/VideoAppContext';
import { AspectPlaceholder } from '../Teaser/Placeholder/AspectPlaceholder';
import { jsx as _jsx } from "react/jsx-runtime";
export const SwipeablePlaceholder = ({
  config,
  placeholder,
  aspectRatio = 16 / 9
}) => {
  const {
    usePreview
  } = useVideoConfig();
  return /*#__PURE__*/_jsx(ContentContainer, {
    children: /*#__PURE__*/_jsx(ScrollContainer, {
      config: config,
      children: times(7, index => /*#__PURE__*/_jsx(Fragment, {
        children: placeholder || /*#__PURE__*/_jsx(AspectPlaceholder, {
          aspectRatio: aspectRatio,
          isPreview: usePreview
        })
      }, index))
    })
  });
};